import { Location } from 'history'
import randomBytes from 'randombytes'
import * as React from 'react'

import { captureError } from '../errors'
import {
  getJerichoCsrfToken,
  getJerichoHeaderUser,
  HeaderUser,
} from '../http-clients/jericho'

// Chegg UI will ultimately provide a hook or some utility like this
export interface CheggHeaderSession {
  user: HeaderUser | undefined
  csrfToken: string
  pageTrackId: string
}

interface TokenAndUser {
  user: HeaderUser | undefined
  csrfToken: string
}

const getUserAndToken = async (cheggUrl: string): Promise<TokenAndUser> => {
  const {
    data: { token },
  } = await getJerichoCsrfToken(cheggUrl)
  const {
    data: { user },
  } = await getJerichoHeaderUser(cheggUrl, token)

  return Promise.resolve({
    csrfToken: token as string,
    user: user as HeaderUser | undefined,
  })
}

const useCheggHeaderSession = (
  location: Location<any>,
  cheggUrl: string,
  loggedIn: boolean
): CheggHeaderSession => {
  const [csrfToken, setCsrfToken] = React.useState<string>('')
  const [user, setUser] = React.useState<HeaderUser | undefined>(undefined)
  const [pageTrackId, setPageTrackId] = React.useState<string>('')

  React.useEffect(() => {
    getUserAndToken(cheggUrl)
      .then(({ csrfToken, user }) => {
        setCsrfToken(csrfToken)
        setUser(user)
      })
      .catch(captureError)
  }, [loggedIn])

  const handleRouteChange = () => {
    setPageTrackId(randomBytes(16).toString('hex'))
  }

  React.useEffect(() => {
    handleRouteChange()
  }, [location.key])

  return { csrfToken, user, pageTrackId }
}

export default useCheggHeaderSession



// WEBPACK FOOTER //
// ./src/utils/hooks/useCheggHeader.ts